// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/sansation);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/sansation);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
  width: 100%;
  margin: auto;
  overflow: auto; /* Allow scroll */
}

#outer {
  display: flex;
  flex-flow: column;
  height: 100%;
  padding: 0;
}

.recp_name i {
  font-size: xx-large; 
}

.bottom_box {
  background: linear-gradient(to top, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82), white; /* Gradient on the upper part */
  background-size: 100% 50%, 100% 100%; /* Adjust size for gradient */
  background-position: top, center; /* Position the gradients */
  display: flex;
  justify-content: center;
  position: fixed; /* Fix the position at the bottom */
  bottom: 0; /* Align to the bottom */
  left: 0; /* Align to the left */
  right: 0; /* Align to the right */
  height: 100px; /* Adjust the height as needed */
  padding: 10px 0; /* Add some padding for better spacing */
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional shadow for effect */
  z-index: 1000; /* Ensure it stays above other content */
  animation: animated-gradient 3s ease alternate infinite; /* Animation */
}

@keyframes animated-gradient {
  0% {
    background-position: 0 0, 0 50%; /* Initial positions */
  }
  50% {
    background-position: 100% 0, 0 50%; /* Animated position */
  }
  100% {
    background-position: 0 0, 0 50%; /* Back to original */
  }
}

#inner_remaining {
  flex-grow: 1;
  overflow: auto; /* Scroll inside this container */
  padding-bottom: 110px; /* Leave space for the fixed bottom box */
}

/* Other styles remain unchanged */
.evaluate {
  width: 98%;
  height: 100%;
  border-radius: 15px;
  font-family: 'Sansation';
  font-style: normal;
  --borderWidth: 5px;
  position: relative;
  border-radius: var(--borderWidth);
  text-align: center;
  font-size: 20px; /* Adjusted font size to be more reactive */
}

.evaluate:after {
  content: '';
  position: absolute;
  top: calc(-1 * var(--borderWidth));
  left: calc(-1 * var(--borderWidth));
  height: calc(100% + var(--borderWidth) * 2);
  width: calc(100% + var(--borderWidth) * 2);
  background: white;
  border-radius: calc(2 * var(--borderWidth));
  z-index: -1;
  animation: animatedgradient 3s ease alternate infinite;
  background-size: 300% 300%;
}

@keyframes animatedgradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.evaluate_upper {
  display: flex;
  flex-flow: column;
  justify-content: center;
}

.evaluate_upper h1 {
  background-image: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 200%;
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  animation: animated-gradient 5s ease infinite;
  font-size: 2.5em; /* Smaller h1 for responsiveness */
  margin:auto;
}

.evaluate ul {
  
  list-style: none;
}

.evaluate ul li {
  display: inline-block;
  margin-top: 1%;
  padding:0.5px;
}

.progressbar {
  text-align: center;
  margin-top: 15px;
  width: 20%; /* Reduced width for smaller progress bar */
  padding: 0;
}

#sbt,
#skp {
  border: none;
  font-family: 'Sansation';
  font-style: normal;
  font-size: 20px; /* Adjusted button font size */
  border: 3px solid black;
  background-color: transparent;
  border-radius: 10px;
  color: #000;
  width: 200px; /* Reduced button size */
  height: 40px;
}

.progressbar li {
  float: left;
  list-style: none;
  width: 16%;
  position: relative;
  text-align: center;
}

.progressbar li:before {
  content: counter(step);
  counter-increment: step;
  font-size: large; /* Made counter size smaller */
  width: 40px;
  height: 40px;
  border: 3px solid #000000;
  display: block;
  border-radius: 50%;
  line-height: 39px;

  color: #000000;
  text-align: center;
  font-weight: bold;
}

.progressbar {
  counter-reset: step -1; /* Start counting from 0 */
}

.blurry {
  opacity: 0.8;
}

.content {
  margin-top: 20px;
}

.recp_name {
  float: right;
  font-family: 'Sansation';
  font-style: normal;
  color: #444444;
  padding-left: 5%;
  margin-right: 20px;
}

.recp_name p {
  font-size: xxx-large; /* Smaller text */
}

table {
  table-layout: fixed;
  word-wrap: break-word;
  margin-top: -50px;
  width: 100%;
  border-collapse: separate;
  border-spacing: 10px 1em;
}

th,
td {
  overflow: hidden;
  font-family: 'Sansation';
  font-style: normal;
  width: fit-content;
  padding-right: 10px;
  vertical-align: top;
  font-size: 18px; /* Reduced text size */
}

td:before {
  content: '✅ ';
}

.instructions {
  padding-left: 5%;
  line-height: 30px;
  font-family: 'Sansation';
  font-style: normal;
  font-size: 18px; /* Made instructions font size smaller */
  color: rgb(77, 76, 76);
}

.instructions li {
  list-style: none;
}

@media screen and (max-width: 1024px) {
  html,
  body {
    height: auto; /* Allow content to dictate height */
    width: 100%;
    margin: 0;
    overflow: auto; /* Allow scroll */
  }

  #ing1 {
    display: none;
  }
  #ing2 {
    display: inline-block;
  }
  .recp_name {
    float: left;
  }
  .recp_name p {
    font-size: xx-large; /* Adjusted font size for responsiveness */
  }
  .instructions {
    float: left;
  }
  .instructions ul {
    padding: 0;
    font-size: medium;
  }
  .instructions h1 {
    font-size: large; /* Smaller heading */
  }
  #inner_remaining {
    height: 100%;
    overflow: auto;
    padding-bottom: 110px; /* Leave space for the fixed bottom box */
  }
  #outer {
    margin-top: 20px;
    display: flex;
    flex-flow: column;
    height: 100%;
    padding-bottom: 0px;
  }
  .evaluate h1 {
    font-size: auto; 
  }
}

@media screen and (max-width: 870px) {
  .evaluate_upper {
    flex-flow: column;
  }
  .progressbar {
    width: 55%; /* Progress bar responsiveness */
  }
}

::-webkit-scrollbar {
  height: 6px; /* Adjusted scrollbar size */
  width: 6px;
  background: rgb(255, 255, 255);
}

::-webkit-scrollbar-thumb:horizontal {
  background: #000;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:vertical {
  background: #000;
  border-radius: 10px;
}

/* Container to hold the ingredients table and list */
.ingredients-container {
  width: 100%;
}

/* Default: hide the list, show the table */
#ing1 {
  display: table; /* Table visible by default */
}

#ing2 {
  display: none; /* List hidden by default */
}

/* On mobile screens (max-width: 1024px), hide the table and show the list */
@media screen and (max-width: 1024px) {
  #ing1 {
    display: none; /* Hide the table */
  }
  
  #ing2 {
    display: block; /* Show the list */
  }
}

table {
  width: 100%; /* Make the table take the full width */
  table-layout: fixed;
  word-wrap: break-word;
  border-collapse: collapse;
  margin-top: 20px;
}

td {
  padding: 10px;
  font-size: 18px;
  border: 1px solid #ccc; /* Add a border to the table cells */
}

/* Style for the list */
ul#ing2 {
  list-style-type: none;
  padding: 0;
  margin: 20px 0;
}

ul#ing2 li {
  font-size: 18px;
  padding: 5px 0;
}

.progressbar {
  display: flex; /* Arrange buttons in a row */
  background-color: lightgray; /* Background color for the entire bar */
  padding: 5px; /* Optional: add padding to give space around the buttons */
  border-radius: 10px; /* Optional: add border radius for rounded corners */
}

.progressbar li {
  width: 50px; /* Set width for buttons */
  height: 50px; /* Set height for buttons */
  margin: 0; /* Remove margin to eliminate gaps */
  background: transparent; /* Ensure buttons have a transparent background */
  cursor: pointer; /* Change cursor to pointer */
  transition: background 0.3s; /* Smooth transition */
}

.progressbar li.active {
  transform: scale(1.25); /* Slightly increase size when active */
  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); Add shadow for effect */
}

#bt0::before {
  background-color: #fc1239;
}

#bt1::before {
  background-color: #f7756b;
}

#bt2::before {
  background-color: #fdde65;
}

#bt3::before {
  background-color: #f5f4a0;
}

#bt4::before {
  background-color: #7dfb74;
}

#bt5::before {
  background-color: #00ff00;
}

.bottom_box {
  background: linear-gradient(to top, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82), white; /* Gradient on the upper part */
  background-size: 100% 50%, 100% 100%; /* Adjust size for gradient */
  display: flex;
  justify-content: center;
  position: sticky; /* Change from fixed to relative */
  margin-top: auto; /* Push it to the bottom */
  height: auto; /* Adjust the height as needed */
  padding: 10px 0; /* Add some padding for better spacing */
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional shadow for effect */
  z-index: 1000; /* Ensure it stays above other content */
  animation: animated-gradient 3s ease alternate infinite; /* Animation */
}

#inner_remaining {
  flex-grow: 1;
  overflow: auto; /* Scroll inside this container */
  padding-bottom: 0; /* No need for padding as the bottom box is now part of the scroll */
}

/* Media Query for Mobile Screens */
@media screen and (max-width: 1024px) {
  #outer {
    display: flex;
    flex-flow: column;
    height: 100vh; /* Set height to viewport height */
    padding-bottom: auto; /* Leave space for the bottom box */
  }

  #inner_remaining {
    height: calc(100% - 100px); /* Adjust height for inner content to fit the screen */
  }
}

.left h1 {
    margin: 0;
    font-size: 24px;
    /* font-family: 'Sansation', sans-serif; Apply the font */
}

/* Adjusted CSS for Bottom Box */
.bottom_box {
  background: linear-gradient(to top, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82), white; /* Gradient on the upper part */
  background-size: 100% 50%, 100% 100%; /* Adjust size for gradient */
  display: flex;
  justify-content: center;
  position: sticky; /* Keep it fixed at the bottom */
  left: 0; /* Align to the left */
  right: 0; /* Align to the right */
  height: 33vh; /* Set height to one-third of the viewport height */
  padding: 10px 0; 
  bottom: 0;/* Add some padding for better spacing */
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional shadow for effect */
  z-index: 1000; /* Ensure it stays above other content */
  animation: animated-gradient 3s ease alternate infinite; /* Animation */
}

#inner_remaining {
  flex-grow: 1;
  overflow: auto; /* Scroll inside this container */
  padding-bottom: 0; /* No need for padding as the bottom box is fixed */
}

/* Media Query for Mobile and Desktop */
@media screen and (max-width: 1024px) {
  #outer {
    display: flex;
    flex-flow: column;
    height: 100vh; /* Set height to viewport height */
    padding-bottom: 33vh; /* Leave space for the bottom box */
  }

  #inner_remaining {
    height: calc(100% - 33vh); /* Adjust height for inner content to fit the screen */
  }
}

.progressbar {
  display: flex; /* Use flexbox to arrange buttons in a row */
  width: 300px; /* Set a fixed width in pixels */
  background-color: lightgray; /* Background color for the entire progress bar */
  border-radius: 10px; /* Optional: add border radius for rounded corners */
  padding: 5px; /* Optional: add padding for spacing */
  margin: 0 auto; /* Center the progress bar */
}


#outer {
  display: flex;
  flex-flow: column;
  /* height: 100%; Ensure it takes full height */
  padding: 0;
}

#inner_remaining {
  flex-grow: 1; /* Allow it to grow to take available space */
  overflow: auto; /* Enable scrolling */
  padding-bottom: 0; /* No padding needed */
  margin-bottom: auto; /* Leave space for the bottom box on PC */
}

.bottom_box {
  background: linear-gradient(to top, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82), white; /* Gradient on the upper part */
  background-size: 100% 50%, 100% 100%; /* Adjust size for gradient */
  display: flex;
  justify-content: center;
  position: sticky; /* Keep it fixed at the bottom */
  left: 0; /* Align to the left */
  right: 0; /* Align to the right */
  height: auto; /* Fixed height for PC */
  padding: 10px 0; /* Add some padding for better spacing */
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional shadow for effect */
  z-index: 1000; /* Ensure it stays above other content */
  animation: animated-gradient 3s ease alternate infinite; /* Animation */
}

/* Media Query for Mobile Screens */
@media screen and (max-width: 1024px) {
  #inner_remaining {
    margin-bottom: auto; /* Leave space for the bottom box on mobile */
  }

  .bottom_box {
    height: auto; /* Set height to one-third of the viewport height for mobile */
  }

  #outer {
    /* height: auto; */
    bottom:0; /* Use viewport height for flexibility */
  }
}

.spacing {
  margin: 20px 0; /* Adjust the value as needed for spacing */
}

.ingredients-container {
  margin-bottom: 20px; /* Space after Ingredients */
}

.instructions {
  margin-top: 20px; /* Space before Recipe Instructions */
}

@media (max-width: 600px) {
  .ingredients-container {
      margin-bottom: 15px; /* Space after Ingredients for mobile */
  }

  .instructions {
      margin-top: 15px; /* Space before Recipe Instructions for mobile */
  }
}

@media screen and (max-width: 1024px) {
  /* Existing styles... */

  /* Adjust margin for ingredients and instructions */
  .ingredients-container {
    margin-bottom: 20px; /* Add margin below ingredients */
  }

  .instructions {
    margin-top: 20px; /* Add margin above instructions to match spacing */
  }
}

.instructions i {
  font-size: xx-large;
}
.recp_name p {
  margin: 0; /* Reset margin */
  padding: 0; /* Reset padding */
}

.recp_name i {
  font-size: x-large; /* Default size for mobile */
}

/* For screens wider than 768px (you can adjust the breakpoint as needed) */
@media (min-width: 768px) {
  .recp_name i {
      font-size: xx-large; /* Size for PC */
  }
}

.instructions i {
  font-size: x-large; /* Default size for mobile */
}

/* For screens wider than 768px */
@media (min-width: 768px) {
  .instructions i {
      font-size: xx-large; /* Size for PC */
  }
}
.left h1 {
  /* font-family: Sansation, sans-serif; */
  font-size: xx-large; /* Default size for mobile */
  margin: 0;
}

/* For screens wider than 768px (you can adjust the breakpoint as needed) */
@media (min-width: 768px) {
  .left h1 {
      font-size: xxx-large; /* Size for PC */
  }
}
.evaluate_upper h1 {
  margin-bottom: 20px;
  padding:5px; /* Adjust the value as needed */
}

li#bt0 {
  margin: auto;
}

li#bt1 {
  margin: auto;
}

li#bt2 {
  margin: auto;
}

li#bt3 {
  margin: auto;
}

li#bt4 {
  margin: auto;
}

li#bt5 {
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/Components/randi.css"],"names":[],"mappings":"AAGA;;EAEE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,iBAAiB;AACnC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kHAAkH,EAAE,+BAA+B;EACnJ,oCAAoC,EAAE,6BAA6B;EACnE,gCAAgC,EAAE,2BAA2B;EAC7D,aAAa;EACb,uBAAuB;EACvB,eAAe,EAAE,mCAAmC;EACpD,SAAS,EAAE,wBAAwB;EACnC,OAAO,EAAE,sBAAsB;EAC/B,QAAQ,EAAE,uBAAuB;EACjC,aAAa,EAAE,gCAAgC;EAC/C,eAAe,EAAE,wCAAwC;EACzD,0CAA0C,EAAE,+BAA+B;EAC3E,aAAa,EAAE,wCAAwC;EACvD,uDAAuD,EAAE,cAAc;AACzE;;AAEA;EACE;IACE,+BAA+B,EAAE,sBAAsB;EACzD;EACA;IACE,kCAAkC,EAAE,sBAAsB;EAC5D;EACA;IACE,+BAA+B,EAAE,qBAAqB;EACxD;AACF;;AAEA;EACE,YAAY;EACZ,cAAc,EAAE,iCAAiC;EACjD,qBAAqB,EAAE,yCAAyC;AAClE;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe,EAAE,2CAA2C;AAC9D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,2CAA2C;EAC3C,0CAA0C;EAC1C,iBAAiB;EACjB,2CAA2C;EAC3C,WAAW;EACX,sDAAsD;EACtD,0BAA0B;AAC5B;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,6EAA6E;EAC7E,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;EAC7B,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB,EAAE,kCAAkC;EACpD,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAE,2CAA2C;EACvD,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe,EAAE,8BAA8B;EAC/C,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,YAAY,EAAE,wBAAwB;EACtC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB,EAAE,8BAA8B;EAChD,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;;EAEjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB,EAAE,0BAA0B;AACpD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB,EAAE,iBAAiB;AACzC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe,EAAE,sBAAsB;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe,EAAE,wCAAwC;EACzD,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,YAAY,EAAE,oCAAoC;IAClD,WAAW;IACX,SAAS;IACT,cAAc,EAAE,iBAAiB;EACnC;;EAEA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB,EAAE,0CAA0C;EACjE;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,gBAAgB,EAAE,oBAAoB;EACxC;EACA;IACE,YAAY;IACZ,cAAc;IACd,qBAAqB,EAAE,yCAAyC;EAClE;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,UAAU,EAAE,gCAAgC;EAC9C;AACF;;AAEA;EACE,WAAW,EAAE,4BAA4B;EACzC,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,aAAa,EAAE,2BAA2B;AAC5C;;AAEA,4EAA4E;AAC5E;EACE;IACE,aAAa,EAAE,mBAAmB;EACpC;;EAEA;IACE,cAAc,EAAE,kBAAkB;EACpC;AACF;;AAEA;EACE,WAAW,EAAE,uCAAuC;EACpD,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB,EAAE,oCAAoC;AAC9D;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa,EAAE,6BAA6B;EAC5C,2BAA2B,EAAE,wCAAwC;EACrE,YAAY,EAAE,2DAA2D;EACzE,mBAAmB,EAAE,oDAAoD;AAC3E;;AAEA;EACE,WAAW,EAAE,0BAA0B;EACvC,YAAY,EAAE,2BAA2B;EACzC,SAAS,EAAE,oCAAoC;EAC/C,uBAAuB,EAAE,iDAAiD;EAC1E,eAAe,EAAE,6BAA6B;EAC9C,2BAA2B,EAAE,sBAAsB;AACrD;;AAEA;EACE,sBAAsB,EAAE,uCAAuC;EAC/D,mEAAmE;AACrE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kHAAkH,EAAE,+BAA+B;EACnJ,oCAAoC,EAAE,6BAA6B;EACnE,aAAa;EACb,uBAAuB;EACvB,gBAAgB,EAAE,kCAAkC;EACpD,gBAAgB,EAAE,0BAA0B;EAC5C,YAAY,EAAE,gCAAgC;EAC9C,eAAe,EAAE,wCAAwC;EACzD,0CAA0C,EAAE,+BAA+B;EAC3E,aAAa,EAAE,wCAAwC;EACvD,uDAAuD,EAAE,cAAc;AACzE;;AAEA;EACE,YAAY;EACZ,cAAc,EAAE,iCAAiC;EACjD,iBAAiB,EAAE,oEAAoE;AACzF;;AAEA,mCAAmC;AACnC;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,aAAa,EAAE,kCAAkC;IACjD,oBAAoB,EAAE,mCAAmC;EAC3D;;EAEA;IACE,0BAA0B,EAAE,sDAAsD;EACpF;AACF;;AAGA;IACI,SAAS;IACT,eAAe;IACf,yDAAyD;AAC7D;;AAEA,gCAAgC;AAChC;EACE,kHAAkH,EAAE,+BAA+B;EACnJ,oCAAoC,EAAE,6BAA6B;EACnE,aAAa;EACb,uBAAuB;EACvB,gBAAgB,EAAE,gCAAgC;EAClD,OAAO,EAAE,sBAAsB;EAC/B,QAAQ,EAAE,uBAAuB;EACjC,YAAY,EAAE,mDAAmD;EACjE,eAAe;EACf,SAAS,CAAC,wCAAwC;EAClD,0CAA0C,EAAE,+BAA+B;EAC3E,aAAa,EAAE,wCAAwC;EACvD,uDAAuD,EAAE,cAAc;AACzE;;AAEA;EACE,YAAY;EACZ,cAAc,EAAE,iCAAiC;EACjD,iBAAiB,EAAE,mDAAmD;AACxE;;AAEA,uCAAuC;AACvC;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,aAAa,EAAE,kCAAkC;IACjD,oBAAoB,EAAE,mCAAmC;EAC3D;;EAEA;IACE,yBAAyB,EAAE,sDAAsD;EACnF;AACF;;AAEA;EACE,aAAa,EAAE,4CAA4C;EAC3D,YAAY,EAAE,gCAAgC;EAC9C,2BAA2B,EAAE,iDAAiD;EAC9E,mBAAmB,EAAE,oDAAoD;EACzE,YAAY,EAAE,sCAAsC;EACpD,cAAc,EAAE,4BAA4B;AAC9C;;;AAGA;EACE,aAAa;EACb,iBAAiB;EACjB,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;EACE,YAAY,EAAE,6CAA6C;EAC3D,cAAc,EAAE,qBAAqB;EACrC,iBAAiB,EAAE,sBAAsB;EACzC,mBAAmB,EAAE,yCAAyC;AAChE;;AAEA;EACE,kHAAkH,EAAE,+BAA+B;EACnJ,oCAAoC,EAAE,6BAA6B;EACnE,aAAa;EACb,uBAAuB;EACvB,gBAAgB,EAAE,gCAAgC;EAClD,OAAO,EAAE,sBAAsB;EAC/B,QAAQ,EAAE,uBAAuB;EACjC,YAAY,EAAE,wBAAwB;EACtC,eAAe,EAAE,wCAAwC;EACzD,0CAA0C,EAAE,+BAA+B;EAC3E,aAAa,EAAE,wCAAwC;EACvD,uDAAuD,EAAE,cAAc;AACzE;;AAEA,mCAAmC;AACnC;EACE;IACE,mBAAmB,EAAE,6CAA6C;EACpE;;EAEA;IACE,YAAY,EAAE,8DAA8D;EAC9E;;EAEA;IACE,kBAAkB;IAClB,QAAQ,EAAE,wCAAwC;EACpD;AACF;;AAEA;EACE,cAAc,EAAE,2CAA2C;AAC7D;;AAEA;EACE,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,gBAAgB,EAAE,qCAAqC;AACzD;;AAEA;EACE;MACI,mBAAmB,EAAE,uCAAuC;EAChE;;EAEA;MACI,gBAAgB,EAAE,gDAAgD;EACtE;AACF;;AAEA;EACE,uBAAuB;;EAEvB,mDAAmD;EACnD;IACE,mBAAmB,EAAE,iCAAiC;EACxD;;EAEA;IACE,gBAAgB,EAAE,mDAAmD;EACvE;AACF;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS,EAAE,iBAAiB;EAC5B,UAAU,EAAE,kBAAkB;AAChC;;AAEA;EACE,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA,2EAA2E;AAC3E;EACE;MACI,mBAAmB,EAAE,gBAAgB;EACzC;AACF;;AAEA;EACE,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA,iCAAiC;AACjC;EACE;MACI,mBAAmB,EAAE,gBAAgB;EACzC;AACF;AACA;EACE,wCAAwC;EACxC,mBAAmB,EAAE,4BAA4B;EACjD,SAAS;AACX;;AAEA,2EAA2E;AAC3E;EACE;MACI,oBAAoB,EAAE,gBAAgB;EAC1C;AACF;AACA;EACE,mBAAmB;EACnB,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap');\r\n@import url('https://fonts.cdnfonts.com/css/sansation');\r\n\r\nhtml,\r\nbody {\r\n  height: 100%;\r\n  width: 100%;\r\n  margin: auto;\r\n  overflow: auto; /* Allow scroll */\r\n}\r\n\r\n#outer {\r\n  display: flex;\r\n  flex-flow: column;\r\n  height: 100%;\r\n  padding: 0;\r\n}\r\n\r\n.recp_name i {\r\n  font-size: xx-large; \r\n}\r\n\r\n.bottom_box {\r\n  background: linear-gradient(to top, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82), white; /* Gradient on the upper part */\r\n  background-size: 100% 50%, 100% 100%; /* Adjust size for gradient */\r\n  background-position: top, center; /* Position the gradients */\r\n  display: flex;\r\n  justify-content: center;\r\n  position: fixed; /* Fix the position at the bottom */\r\n  bottom: 0; /* Align to the bottom */\r\n  left: 0; /* Align to the left */\r\n  right: 0; /* Align to the right */\r\n  height: 100px; /* Adjust the height as needed */\r\n  padding: 10px 0; /* Add some padding for better spacing */\r\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional shadow for effect */\r\n  z-index: 1000; /* Ensure it stays above other content */\r\n  animation: animated-gradient 3s ease alternate infinite; /* Animation */\r\n}\r\n\r\n@keyframes animated-gradient {\r\n  0% {\r\n    background-position: 0 0, 0 50%; /* Initial positions */\r\n  }\r\n  50% {\r\n    background-position: 100% 0, 0 50%; /* Animated position */\r\n  }\r\n  100% {\r\n    background-position: 0 0, 0 50%; /* Back to original */\r\n  }\r\n}\r\n\r\n#inner_remaining {\r\n  flex-grow: 1;\r\n  overflow: auto; /* Scroll inside this container */\r\n  padding-bottom: 110px; /* Leave space for the fixed bottom box */\r\n}\r\n\r\n/* Other styles remain unchanged */\r\n.evaluate {\r\n  width: 98%;\r\n  height: 100%;\r\n  border-radius: 15px;\r\n  font-family: 'Sansation';\r\n  font-style: normal;\r\n  --borderWidth: 5px;\r\n  position: relative;\r\n  border-radius: var(--borderWidth);\r\n  text-align: center;\r\n  font-size: 20px; /* Adjusted font size to be more reactive */\r\n}\r\n\r\n.evaluate:after {\r\n  content: '';\r\n  position: absolute;\r\n  top: calc(-1 * var(--borderWidth));\r\n  left: calc(-1 * var(--borderWidth));\r\n  height: calc(100% + var(--borderWidth) * 2);\r\n  width: calc(100% + var(--borderWidth) * 2);\r\n  background: white;\r\n  border-radius: calc(2 * var(--borderWidth));\r\n  z-index: -1;\r\n  animation: animatedgradient 3s ease alternate infinite;\r\n  background-size: 300% 300%;\r\n}\r\n\r\n@keyframes animatedgradient {\r\n  0% {\r\n    background-position: 0% 50%;\r\n  }\r\n  50% {\r\n    background-position: 100% 50%;\r\n  }\r\n  100% {\r\n    background-position: 0% 50%;\r\n  }\r\n}\r\n\r\n.evaluate_upper {\r\n  display: flex;\r\n  flex-flow: column;\r\n  justify-content: center;\r\n}\r\n\r\n.evaluate_upper h1 {\r\n  background-image: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);\r\n  background-size: 200%;\r\n  -webkit-text-fill-color: transparent;\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  animation: animated-gradient 5s ease infinite;\r\n  font-size: 2.5em; /* Smaller h1 for responsiveness */\r\n  margin:auto;\r\n}\r\n\r\n.evaluate ul {\r\n  \r\n  list-style: none;\r\n}\r\n\r\n.evaluate ul li {\r\n  display: inline-block;\r\n  margin-top: 1%;\r\n  padding:0.5px;\r\n}\r\n\r\n.progressbar {\r\n  text-align: center;\r\n  margin-top: 15px;\r\n  width: 20%; /* Reduced width for smaller progress bar */\r\n  padding: 0;\r\n}\r\n\r\n#sbt,\r\n#skp {\r\n  border: none;\r\n  font-family: 'Sansation';\r\n  font-style: normal;\r\n  font-size: 20px; /* Adjusted button font size */\r\n  border: 3px solid black;\r\n  background-color: transparent;\r\n  border-radius: 10px;\r\n  color: #000;\r\n  width: 200px; /* Reduced button size */\r\n  height: 40px;\r\n}\r\n\r\n.progressbar li {\r\n  float: left;\r\n  list-style: none;\r\n  width: 16%;\r\n  position: relative;\r\n  text-align: center;\r\n}\r\n\r\n.progressbar li:before {\r\n  content: counter(step);\r\n  counter-increment: step;\r\n  font-size: large; /* Made counter size smaller */\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 3px solid #000000;\r\n  display: block;\r\n  border-radius: 50%;\r\n  line-height: 39px;\r\n\r\n  color: #000000;\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.progressbar {\r\n  counter-reset: step -1; /* Start counting from 0 */\r\n}\r\n\r\n.blurry {\r\n  opacity: 0.8;\r\n}\r\n\r\n.content {\r\n  margin-top: 20px;\r\n}\r\n\r\n.recp_name {\r\n  float: right;\r\n  font-family: 'Sansation';\r\n  font-style: normal;\r\n  color: #444444;\r\n  padding-left: 5%;\r\n  margin-right: 20px;\r\n}\r\n\r\n.recp_name p {\r\n  font-size: xxx-large; /* Smaller text */\r\n}\r\n\r\ntable {\r\n  table-layout: fixed;\r\n  word-wrap: break-word;\r\n  margin-top: -50px;\r\n  width: 100%;\r\n  border-collapse: separate;\r\n  border-spacing: 10px 1em;\r\n}\r\n\r\nth,\r\ntd {\r\n  overflow: hidden;\r\n  font-family: 'Sansation';\r\n  font-style: normal;\r\n  width: fit-content;\r\n  padding-right: 10px;\r\n  vertical-align: top;\r\n  font-size: 18px; /* Reduced text size */\r\n}\r\n\r\ntd:before {\r\n  content: '✅ ';\r\n}\r\n\r\n.instructions {\r\n  padding-left: 5%;\r\n  line-height: 30px;\r\n  font-family: 'Sansation';\r\n  font-style: normal;\r\n  font-size: 18px; /* Made instructions font size smaller */\r\n  color: rgb(77, 76, 76);\r\n}\r\n\r\n.instructions li {\r\n  list-style: none;\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  html,\r\n  body {\r\n    height: auto; /* Allow content to dictate height */\r\n    width: 100%;\r\n    margin: 0;\r\n    overflow: auto; /* Allow scroll */\r\n  }\r\n\r\n  #ing1 {\r\n    display: none;\r\n  }\r\n  #ing2 {\r\n    display: inline-block;\r\n  }\r\n  .recp_name {\r\n    float: left;\r\n  }\r\n  .recp_name p {\r\n    font-size: xx-large; /* Adjusted font size for responsiveness */\r\n  }\r\n  .instructions {\r\n    float: left;\r\n  }\r\n  .instructions ul {\r\n    padding: 0;\r\n    font-size: medium;\r\n  }\r\n  .instructions h1 {\r\n    font-size: large; /* Smaller heading */\r\n  }\r\n  #inner_remaining {\r\n    height: 100%;\r\n    overflow: auto;\r\n    padding-bottom: 110px; /* Leave space for the fixed bottom box */\r\n  }\r\n  #outer {\r\n    margin-top: 20px;\r\n    display: flex;\r\n    flex-flow: column;\r\n    height: 100%;\r\n    padding-bottom: 0px;\r\n  }\r\n  .evaluate h1 {\r\n    font-size: auto; \r\n  }\r\n}\r\n\r\n@media screen and (max-width: 870px) {\r\n  .evaluate_upper {\r\n    flex-flow: column;\r\n  }\r\n  .progressbar {\r\n    width: 55%; /* Progress bar responsiveness */\r\n  }\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  height: 6px; /* Adjusted scrollbar size */\r\n  width: 6px;\r\n  background: rgb(255, 255, 255);\r\n}\r\n\r\n::-webkit-scrollbar-thumb:horizontal {\r\n  background: #000;\r\n  border-radius: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:vertical {\r\n  background: #000;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Container to hold the ingredients table and list */\r\n.ingredients-container {\r\n  width: 100%;\r\n}\r\n\r\n/* Default: hide the list, show the table */\r\n#ing1 {\r\n  display: table; /* Table visible by default */\r\n}\r\n\r\n#ing2 {\r\n  display: none; /* List hidden by default */\r\n}\r\n\r\n/* On mobile screens (max-width: 1024px), hide the table and show the list */\r\n@media screen and (max-width: 1024px) {\r\n  #ing1 {\r\n    display: none; /* Hide the table */\r\n  }\r\n  \r\n  #ing2 {\r\n    display: block; /* Show the list */\r\n  }\r\n}\r\n\r\ntable {\r\n  width: 100%; /* Make the table take the full width */\r\n  table-layout: fixed;\r\n  word-wrap: break-word;\r\n  border-collapse: collapse;\r\n  margin-top: 20px;\r\n}\r\n\r\ntd {\r\n  padding: 10px;\r\n  font-size: 18px;\r\n  border: 1px solid #ccc; /* Add a border to the table cells */\r\n}\r\n\r\n/* Style for the list */\r\nul#ing2 {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 20px 0;\r\n}\r\n\r\nul#ing2 li {\r\n  font-size: 18px;\r\n  padding: 5px 0;\r\n}\r\n\r\n.progressbar {\r\n  display: flex; /* Arrange buttons in a row */\r\n  background-color: lightgray; /* Background color for the entire bar */\r\n  padding: 5px; /* Optional: add padding to give space around the buttons */\r\n  border-radius: 10px; /* Optional: add border radius for rounded corners */\r\n}\r\n\r\n.progressbar li {\r\n  width: 50px; /* Set width for buttons */\r\n  height: 50px; /* Set height for buttons */\r\n  margin: 0; /* Remove margin to eliminate gaps */\r\n  background: transparent; /* Ensure buttons have a transparent background */\r\n  cursor: pointer; /* Change cursor to pointer */\r\n  transition: background 0.3s; /* Smooth transition */\r\n}\r\n\r\n.progressbar li.active {\r\n  transform: scale(1.25); /* Slightly increase size when active */\r\n  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); Add shadow for effect */\r\n}\r\n\r\n#bt0::before {\r\n  background-color: #fc1239;\r\n}\r\n\r\n#bt1::before {\r\n  background-color: #f7756b;\r\n}\r\n\r\n#bt2::before {\r\n  background-color: #fdde65;\r\n}\r\n\r\n#bt3::before {\r\n  background-color: #f5f4a0;\r\n}\r\n\r\n#bt4::before {\r\n  background-color: #7dfb74;\r\n}\r\n\r\n#bt5::before {\r\n  background-color: #00ff00;\r\n}\r\n\r\n.bottom_box {\r\n  background: linear-gradient(to top, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82), white; /* Gradient on the upper part */\r\n  background-size: 100% 50%, 100% 100%; /* Adjust size for gradient */\r\n  display: flex;\r\n  justify-content: center;\r\n  position: sticky; /* Change from fixed to relative */\r\n  margin-top: auto; /* Push it to the bottom */\r\n  height: auto; /* Adjust the height as needed */\r\n  padding: 10px 0; /* Add some padding for better spacing */\r\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional shadow for effect */\r\n  z-index: 1000; /* Ensure it stays above other content */\r\n  animation: animated-gradient 3s ease alternate infinite; /* Animation */\r\n}\r\n\r\n#inner_remaining {\r\n  flex-grow: 1;\r\n  overflow: auto; /* Scroll inside this container */\r\n  padding-bottom: 0; /* No need for padding as the bottom box is now part of the scroll */\r\n}\r\n\r\n/* Media Query for Mobile Screens */\r\n@media screen and (max-width: 1024px) {\r\n  #outer {\r\n    display: flex;\r\n    flex-flow: column;\r\n    height: 100vh; /* Set height to viewport height */\r\n    padding-bottom: auto; /* Leave space for the bottom box */\r\n  }\r\n\r\n  #inner_remaining {\r\n    height: calc(100% - 100px); /* Adjust height for inner content to fit the screen */\r\n  }\r\n}\r\n@import url('https://fonts.cdnfonts.com/css/sansation');\r\n\r\n.left h1 {\r\n    margin: 0;\r\n    font-size: 24px;\r\n    /* font-family: 'Sansation', sans-serif; Apply the font */\r\n}\r\n\r\n/* Adjusted CSS for Bottom Box */\r\n.bottom_box {\r\n  background: linear-gradient(to top, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82), white; /* Gradient on the upper part */\r\n  background-size: 100% 50%, 100% 100%; /* Adjust size for gradient */\r\n  display: flex;\r\n  justify-content: center;\r\n  position: sticky; /* Keep it fixed at the bottom */\r\n  left: 0; /* Align to the left */\r\n  right: 0; /* Align to the right */\r\n  height: 33vh; /* Set height to one-third of the viewport height */\r\n  padding: 10px 0; \r\n  bottom: 0;/* Add some padding for better spacing */\r\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional shadow for effect */\r\n  z-index: 1000; /* Ensure it stays above other content */\r\n  animation: animated-gradient 3s ease alternate infinite; /* Animation */\r\n}\r\n\r\n#inner_remaining {\r\n  flex-grow: 1;\r\n  overflow: auto; /* Scroll inside this container */\r\n  padding-bottom: 0; /* No need for padding as the bottom box is fixed */\r\n}\r\n\r\n/* Media Query for Mobile and Desktop */\r\n@media screen and (max-width: 1024px) {\r\n  #outer {\r\n    display: flex;\r\n    flex-flow: column;\r\n    height: 100vh; /* Set height to viewport height */\r\n    padding-bottom: 33vh; /* Leave space for the bottom box */\r\n  }\r\n\r\n  #inner_remaining {\r\n    height: calc(100% - 33vh); /* Adjust height for inner content to fit the screen */\r\n  }\r\n}\r\n\r\n.progressbar {\r\n  display: flex; /* Use flexbox to arrange buttons in a row */\r\n  width: 300px; /* Set a fixed width in pixels */\r\n  background-color: lightgray; /* Background color for the entire progress bar */\r\n  border-radius: 10px; /* Optional: add border radius for rounded corners */\r\n  padding: 5px; /* Optional: add padding for spacing */\r\n  margin: 0 auto; /* Center the progress bar */\r\n}\r\n\r\n\r\n#outer {\r\n  display: flex;\r\n  flex-flow: column;\r\n  /* height: 100%; Ensure it takes full height */\r\n  padding: 0;\r\n}\r\n\r\n#inner_remaining {\r\n  flex-grow: 1; /* Allow it to grow to take available space */\r\n  overflow: auto; /* Enable scrolling */\r\n  padding-bottom: 0; /* No padding needed */\r\n  margin-bottom: auto; /* Leave space for the bottom box on PC */\r\n}\r\n\r\n.bottom_box {\r\n  background: linear-gradient(to top, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82), white; /* Gradient on the upper part */\r\n  background-size: 100% 50%, 100% 100%; /* Adjust size for gradient */\r\n  display: flex;\r\n  justify-content: center;\r\n  position: sticky; /* Keep it fixed at the bottom */\r\n  left: 0; /* Align to the left */\r\n  right: 0; /* Align to the right */\r\n  height: auto; /* Fixed height for PC */\r\n  padding: 10px 0; /* Add some padding for better spacing */\r\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Optional shadow for effect */\r\n  z-index: 1000; /* Ensure it stays above other content */\r\n  animation: animated-gradient 3s ease alternate infinite; /* Animation */\r\n}\r\n\r\n/* Media Query for Mobile Screens */\r\n@media screen and (max-width: 1024px) {\r\n  #inner_remaining {\r\n    margin-bottom: auto; /* Leave space for the bottom box on mobile */\r\n  }\r\n\r\n  .bottom_box {\r\n    height: auto; /* Set height to one-third of the viewport height for mobile */\r\n  }\r\n\r\n  #outer {\r\n    /* height: auto; */\r\n    bottom:0; /* Use viewport height for flexibility */\r\n  }\r\n}\r\n\r\n.spacing {\r\n  margin: 20px 0; /* Adjust the value as needed for spacing */\r\n}\r\n\r\n.ingredients-container {\r\n  margin-bottom: 20px; /* Space after Ingredients */\r\n}\r\n\r\n.instructions {\r\n  margin-top: 20px; /* Space before Recipe Instructions */\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .ingredients-container {\r\n      margin-bottom: 15px; /* Space after Ingredients for mobile */\r\n  }\r\n\r\n  .instructions {\r\n      margin-top: 15px; /* Space before Recipe Instructions for mobile */\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  /* Existing styles... */\r\n\r\n  /* Adjust margin for ingredients and instructions */\r\n  .ingredients-container {\r\n    margin-bottom: 20px; /* Add margin below ingredients */\r\n  }\r\n\r\n  .instructions {\r\n    margin-top: 20px; /* Add margin above instructions to match spacing */\r\n  }\r\n}\r\n\r\n.instructions i {\r\n  font-size: xx-large;\r\n}\r\n.recp_name p {\r\n  margin: 0; /* Reset margin */\r\n  padding: 0; /* Reset padding */\r\n}\r\n\r\n.recp_name i {\r\n  font-size: x-large; /* Default size for mobile */\r\n}\r\n\r\n/* For screens wider than 768px (you can adjust the breakpoint as needed) */\r\n@media (min-width: 768px) {\r\n  .recp_name i {\r\n      font-size: xx-large; /* Size for PC */\r\n  }\r\n}\r\n\r\n.instructions i {\r\n  font-size: x-large; /* Default size for mobile */\r\n}\r\n\r\n/* For screens wider than 768px */\r\n@media (min-width: 768px) {\r\n  .instructions i {\r\n      font-size: xx-large; /* Size for PC */\r\n  }\r\n}\r\n.left h1 {\r\n  /* font-family: Sansation, sans-serif; */\r\n  font-size: xx-large; /* Default size for mobile */\r\n  margin: 0;\r\n}\r\n\r\n/* For screens wider than 768px (you can adjust the breakpoint as needed) */\r\n@media (min-width: 768px) {\r\n  .left h1 {\r\n      font-size: xxx-large; /* Size for PC */\r\n  }\r\n}\r\n.evaluate_upper h1 {\r\n  margin-bottom: 20px;\r\n  padding:5px; /* Adjust the value as needed */\r\n}\r\n\r\nli#bt0 {\r\n  margin: auto;\r\n}\r\n\r\nli#bt1 {\r\n  margin: auto;\r\n}\r\n\r\nli#bt2 {\r\n  margin: auto;\r\n}\r\n\r\nli#bt3 {\r\n  margin: auto;\r\n}\r\n\r\nli#bt4 {\r\n  margin: auto;\r\n}\r\n\r\nli#bt5 {\r\n  margin: auto;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
